{
  "it": {
    "installment": {
      "actions": {
        "bulkEdit": {
          "detail": "Modifica dettagli",
          "reminder": "Modifica promemoria"
        },
        "closeAllRows": "Chiudi tutte le righe",
        "deleteCount": "Sta per eliminare {count} rata. È sicuro? | Sta per eliminare {count} rate. È sicuro?",
        "delete_installments": "Elimina rata | Elimina rate",
        "edit": "Modifica",
        "newInstallment": "Nuovo gruppo di rate",
        "openAllRows": "Apri tutte le righe",
        "publish": "Pubblica",
        "publishCustomer": "Pubblica...",
        "save": "Aggiorna",
        "unpublish": "Annulla pubblicazione",
        "updateStatus": "Aggiorna stato",
        "uploadInvoice": "Carica fattura"
      },
      "attributes": {
        "amount": "Importo",
        "customer": "Cliente",
        "description": "Descrizione",
        "due_date": "Scadenza",
        "group_name": "Gruppo di rate",
        "paid_at": "Pagato il",
        "status_deadline": "Stato",
        "unit": "Unità"
      },
      "edit_actions": {
        "edit_amount": "Importi",
        "edit_deadline": "Scadenza",
        "edit_description": "Descrizione",
        "edit_status": "Stato"
      },
      "labels": {
        "cantEditFractions": "Imposti lo stato della rata su \"Bozza\" per modificare le regole.",
        "changeStatusRequested": "Cambio di stato delle rate da \"Bozza\" a \"Fatturata\"",
        "changeVisibility": "Modifica visibilità...",
        "change_amounts": "Modifica importi",
        "clear_due_date": "Svuota la scadenza di tutte le rate selezionate",
        "clear_paid_at": "Svuota la data di pagamento di tutte le rate selezionate",
        "countEdit": "Modifica rata per 1 unità | Modifica rata per {count} unità",
        "created_at": "Creato il {created_at}",
        "deleteExplanation": "Tutte le rate e le fatture saranno rimosse definitivamente dalla piattaforma.",
        "deleteExplanationGroup": "Poiché saranno rimosse tutte le rate di questo gruppo, anche il gruppo di rate verrà eliminato.",
        "details": "Dettagli",
        "edit": "Modifica rate",
        "editDueDate": "Modifica scadenza",
        "editInstallmentTerm": "Modifica rata",
        "excl_vat": "IVA esclusa",
        "giveNewAmount": "Inserisca il nuovo importo",
        "goToUnitInstallments": "Vai alle rate dell'unità",
        "installmentNoteExplainer": "Questa nota è visibile solo ai membri del team.",
        "installment_categories": "Categorie personalizzate",
        "invoices": "1 fattura | {count} fatture",
        "new_installment_fraction_category": "Categoria",
        "noDeadline": "Nessuna scadenza",
        "notPublished": "Non pubblicata",
        "paid": "Pagata",
        "published": "Pubblicata",
        "publishedCustomer": "Pubblicata per il cliente",
        "publishingForCustomers": "È sicuro?",
        "selectOne": "Selezioni almeno 1 rata",
        "selected": "{selected} rata selezionata. | {selected} rate selezionate.",
        "setDueDate": "Imposta scadenza",
        "statusExplained": "Cosa significa ogni stato della rata?",
        "status_click_to_change": "Faccia clic per modificare",
        "status_deadline": "Stato",
        "statuses": {
          "draft": "Bozza",
          "expected": "Prevista",
          "overdue": "Scaduta",
          "paid": "Pagata",
          "requested": "Fatturata"
        },
        "toBePaid": "Da pagare",
        "total": "Totale",
        "unitInstallmentsWillBeShownHere": "Le rate dell'unità verranno mostrate qui",
        "unpublishingForCustomers": "Annullamento della pubblicazione delle rate per il cliente. È sicuro?",
        "updateStatusCount": "Aggiorna lo stato di 1 rata | Aggiorna lo stato di {count} rate",
        "uploadInvoiceCount": "Carica la fattura per 1 rata | Carica la fattura per {count} rate",
        "uploadInvoiceUnit": "Carica la fattura per {unit_name}",
        "vat": "IVA",
        "vat_with_percentage": "{percentage}% IVA",
        "view_list": "Elenco"
      },
      "legend": {
        "installmentDraft": "Rata in bozza",
        "installmentDraftAfterDueDate": "Rata in bozza",
        "installmentExpired": "Scadenza superata",
        "installmentPaid": "Rata già pagata",
        "installmentPaidAfterDue": "Rata pagata dopo la scadenza",
        "installmentRequested": "Fatturata",
        "reminders": {
          "active": "È stato impostato almeno 1 promemoria",
          "none": "Non è stato impostato alcun promemoria"
        }
      },
      "placeholders": {
        "customers": {
          "documents": {
            "subtitle": "Tutti i documenti delle rate verranno mostrati qui.",
            "title": "Nessun documento ancora"
          },
          "new": {
            "subtitle": "Presto nuove rate"
          }
        }
      },
      "sort_options": {
        "due_date": "Scadenza",
        "due_date asc": "Scadenza più lontana prima",
        "due_date desc": "Scadenza più vicina prima",
        "group_name": "Nome",
        "group_name asc": "Nome A-Z",
        "group_name desc": "Nome Z-A",
        "status": "Stato",
        "status asc": "Stato A-Z",
        "status desc": "Stato Z-A",
        "updated_at asc": "Aggiornamento più recente prima",
        "updated_at desc": "Aggiornamento meno recente prima"
      },
      "validation": {
        "needNumber": "È necessario un numero (es. 8400,5)"
      }
    }
  }
}
